import { IconComponents } from '../../assets/icons/icons';
import { shareToFacebook, shareToLine, shareToX } from '../../utils/app.utils';
import { Alert, Button, IconButton, Typography } from '@mui/material'
import React, { useState, useTransition } from 'react'
import InsertLinkIcon from '@mui/icons-material/InsertLink';
import { useTranslation } from 'react-i18next';
import Snackbar, { SnackbarOrigin } from '@mui/material/Snackbar';

type Props = {
    line_link?: string;
    x_link?: string;
    facebook_link?: string;
    textX?: string;
    copy?: string;
    textLine?: string;
    callback_line_click?: () => void;
    callback_x_click?: () => void;
    callback_facebook_click?: () => void;
}
interface State extends SnackbarOrigin {
    open: boolean;
}

const SharedContent: React.FC<Props> = ({ facebook_link, callback_facebook_click, callback_line_click, callback_x_click, line_link, textLine, x_link, copy, textX }: Props) => {
    const { t } = useTranslation();
    const [state, setState] = React.useState<State>({
        open: false,
        vertical: 'top',
        horizontal: 'center',
    });
    const { vertical, horizontal, open } = state;

    const [isPending, startTransition] = useTransition();
    const [loading, setLoading] = useState<boolean>(false);

    const handleClick = (newState: SnackbarOrigin) => {
        startTransition(() => {
            if (copy) {
                setLoading(true);
                navigator.clipboard.writeText(copy);
                setTimeout(() => {
                    setState({ ...newState, open: true });
                    setLoading(false);
                }, 1000)
            }
        })
    };

    const handleClose = () => {
        setState({ ...state, open: false });
    };

    return (
        <div className='w-full'>
            <span className='flex flex-wrap md:flex-nowrap gap-2 md:gap-0 justify-start items-center'>
                <Typography mr={2}>{t("แชร์")}</Typography>
                {line_link && (
                    <IconButton
                        onClick={() => {
                            callback_line_click?.();
                            shareToLine(line_link, textLine)
                        }}
                    >
                        <IconComponents.LineColorIcon />
                    </IconButton>
                )}
                {facebook_link && (
                    <IconButton
                        onClick={() => {
                            callback_facebook_click?.();
                            shareToFacebook(facebook_link)
                        }}
                    >
                        <IconComponents.FacebookColorIcon />
                    </IconButton>
                )}
                {x_link && (
                    <IconButton
                        onClick={() => {
                            callback_x_click?.();
                            shareToX(x_link, textX)
                        }}
                    >
                        <IconComponents.XColorIcon />
                    </IconButton>
                )}
                {copy && (
                    <Button disabled={isPending || loading} onClick={() => handleClick({ vertical: 'bottom', horizontal: 'right' })} sx={{ ml: 1, maxWidth: 'fit-content' }} variant='contained' color='success' startIcon={<InsertLinkIcon />}>
                        {loading ? t("กำลังคัดลอก...") : t("คัดลอกลิงก์")}
                    </Button>
                )}
            </span>
            <Snackbar
                anchorOrigin={{ vertical, horizontal }}
                open={open}
                autoHideDuration={6000}
                onClose={handleClose}>
                <Alert
                    onClose={handleClose}
                    severity="success"
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {t("คัดลอกสำเร็จ")}
                </Alert>
            </Snackbar>
        </div>
    )
}

export default SharedContent